import * as React from "react";
const Geo = (props) => (
  <svg
    width={115}
    height={113}
    viewBox="0 0 115 113"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M71.875 5.1875H115V113H0V0.0776367L71.875 71.9526V5.1875ZM7.1875 105.812H95.5151L7.1875 17.4849V105.812ZM98.5474 98.625L105.735 105.812H107.812V12.375H79.0625V19.5625H93.4375V26.75H79.0625V33.9375H93.4375V41.125H79.0625V48.3125H100.625V55.5H79.0625V62.6875H93.4375V69.875H79.0625V77.0625H93.4375V84.25H84.1724L91.3599 91.4375H100.625V98.625H98.5474ZM21.5625 57.5776L55.4224 91.4375H21.5625V57.5776ZM28.75 74.9849V84.25H38.0151L28.75 74.9849Z"
      fill="white"
    />
  </svg>
);
export default Geo;
